'use client';
import { useCallback, useEffect, useState } from 'react';

// Borrowed from https://usehooks-ts.com/react-hook/use-media-query
const useMediaQuery = (query) => {
  const getMatches = useCallback((query) => {
    // Prevents SSR issues
    if (typeof window !== 'undefined' && window.matchMedia) {
      return window.matchMedia(query).matches;
    }
    return false;
  }, []);

  const [matches, setMatches] = useState(false);

  const handleChange = useCallback(() => {
    setMatches(getMatches(query));
  }, [query, getMatches]);

  useEffect(() => {
    // Verify that window & window.matchMedia exist to prevent SSR issues
    if (typeof window === 'undefined' || !window.matchMedia) {
      return;
    }

    const matchMedia = window.matchMedia(query);

    // Triggered at the first client-side load and if query changes
    handleChange();

    // Listen matchMedia
    if (matchMedia.addListener) {
      matchMedia.addListener(handleChange);
    } else {
      matchMedia.addEventListener('change', handleChange);
    }

    return () => {
      if (matchMedia.removeListener) {
        matchMedia.removeListener(handleChange);
      } else {
        matchMedia.removeEventListener('change', handleChange);
      }
    };
  }, [query, handleChange]);

  return matches;
};

export default useMediaQuery;
